import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import paymentModel from '@/models/payment';
import routes from '@/routes';
import { setPrice } from '@/store/checkout';
import { setCurrency } from '@/store/profile';
import { showError } from '@/utils';

export function useHandleRetry() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	return async function ({ priceId: priceIdParam, handlerId, currency }) {
		try {
			let priceId = priceIdParam;

			if (!priceId) {
				const response = await paymentModel.getByHandlerId(handlerId);

				priceId = response?.priceId || null;
			}

			dispatch(
				setPrice({
					id: priceId,
					paymentHandlerId: handlerId
				})
			);

			if (currency) {
				dispatch(setCurrency(currency));
			}

			navigate(routes.checkout);
		} catch (error) {
			showError(error);
		}
	};
}
